// export const baseUrl = './php/';

// Testing
// export const baseUrl = 'http://192.168.1.103/insync/internal/php/';
// export const baseAPI = 'http://localhost:3000';

// Live
export const baseUrl = 'https://inspeqtech.com/insync/internal/php/';
export const baseAPI = 'https://inspeqtech.com/nodey';

export const baseAPIWithoutNodey = 'https://inspeqtech.com';

export const IMG_ROOT = 'https://inspeqtech.com/images/dashboard';

export const loginFile = 'insyncLoginGateway.php';

export const gatewayFile = 'insyncGateway.php';

export const countriesGateway = 'countriesGateway.php';

export const branchesGateway = 'branchesGateway.php';

export const versionFile = 'appVer.php';

export const getInspectorInfo = 'getInspectorInfo.php';

export const myDayGateway = 'myDayGateway.php';

export const heuristicsGateway = 'heuristicsGateway.php';

export const activeWoGateway = 'activeWoGateway.php';

export const myBranchGateway = 'myBranchGateway.php';

export const getTrainingVideosAPI = `${baseAPI}/insync/getTrainingVideos`;
export const watchTrainingVideoAPI = `${baseAPI}/insync/watchTrainingVideo`;
